import { render, staticRenderFns } from "./FoldTree.vue?vue&type=template&id=059d408d&scoped=true&"
import script from "./FoldTree.vue?vue&type=script&lang=ts&"
export * from "./FoldTree.vue?vue&type=script&lang=ts&"
import style0 from "./FoldTree.vue?vue&type=style&index=0&id=059d408d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059d408d",
  null
  
)

export default component.exports